import { render, staticRenderFns } from "./ClaimTypes.vue?vue&type=template&id=b8683140&lang=pug&"
import script from "./ClaimTypes.vue?vue&type=script&lang=js&"
export * from "./ClaimTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports